import { render } from "./OfferMasterCategory.vue?vue&type=template&id=122752ac&scoped=true"
import script from "./OfferMasterCategory.vue?vue&type=script&lang=js"
export * from "./OfferMasterCategory.vue?vue&type=script&lang=js"

import "./OfferMasterCategory.vue?vue&type=style&index=0&id=122752ac&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122752ac"]])

export default __exports__